module.exports = __webpack_public_path__ + "media/home1-left.1c42c86d.mp4";